import React from 'react';
type SectionHeadingProps = {
  title: React.ReactNode;
  intro?: React.ReactNode;
  align?: 'center' | 'left';
  tone?: 'ink' | 'light';
  className?: string;
};
export function SectionHeading({
  title,
  intro,
  align = 'center',
  tone = 'ink',
  className = ''
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'mx-auto text-center' : 'text-left';
  return <div className={`max-w-3xl ${alignment} ${className}`} data-id="element-181" data-mp="3k2025635l64o">
      <h2 className={`text-balance font-display text-[31px] leading-[1.1] sm:text-[42px] lg:text-[50px] ${tone === 'ink' ? 'text-ink' : 'text-cream'}`} data-id="element-182" data-mp="blolhjj1gwaf">
        {title}
      </h2>
      {intro && <div className={`mt-4 text-[17px] leading-relaxed sm:text-lg ${tone === 'ink' ? 'text-ink-soft' : 'text-cream/80'}`} data-id="element-183" data-mp="1uadsogxoq67">{intro}</div>}
    </div>;
}